import type { Profession } from '@shared/types'

interface ProfessionalsListHeaderProps {
  profession?: Profession
}

export function ProfessionalsListHeader({
  profession
}: ProfessionalsListHeaderProps) {
  // if (isLoading) {
  //   return (
  //     <div className="mb-4 pb-3 border-b border-muted-foreground/50">
  //       <div className="h-10 bg-muted animate-pulse rounded mb-2"></div>
  //       <div className="h-5 bg-muted animate-pulse rounded w-3/4"></div>
  //     </div>
  //   )
  // }

  return (
    <div className="mb-4 pb-3 border-b border-muted-foreground/50">
      <h1 className='text-4xl font-bold mb-2'>
        {profession?.name || 'Profesionales'}
      </h1>
      <p className="text-muted-foreground">
        {profession?.description}
      </p>
    </div>
  )
}
